export interface IShadows {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
}

const shadows: IShadows = {
  xs: '0 0.4rem 0.8rem rgba(0, 0, 0, 0.08)',
  sm: '0 0.6rem 1.2rem rgba(0, 0, 0, 0.11)',
  md: '0 0.9rem 1.8rem rgba(0, 0, 0, 0.15)',
  lg: '0 1.3rem 3.7rem rgba(0, 0, 0, 0.21)',
  xl: '0 2.5rem 5.0rem -1.2rem rgba(16, 24, 40, 0.25)',
};

export default shadows;